import useRouter from "@stadium/hooks/lib/use-custom-route";

import { useModal } from "@stadium/hooks/lib/use-modal";
import { useStoreContext } from "@components/store/provider";

import Multimedia from "@sharedComponents/multimedia";
import ProductDetailsModal from "@components/store/product-details-modal";
import Button from "@stadium/ui/src/components/button/button";

import { getPreviewCatalogModalDetail } from "@helpers/catalog";

import { PRODUCT_DETAILS_MODAL } from "@constants/modal-types";
import { getProductRoute } from "@constants/routes";

import NoImage from "@assets/images/no-image.svg";

import main from "./main.module.scss";

const SearchedProducts = ({ data, setSearchValue }) => {
  const { id, name, brand, baseImage, slug, broken = false, brokenVariantId = "" } = data;

  const brandName = brand?.displayName;
  const {
    openModal: openProductDetailsModalCatalog,
    renderModal: renderProductDetailsModalCatalog,
  } = useModal(PRODUCT_DETAILS_MODAL, ProductDetailsModal);
  const { storeBasePath, isPreviewCatalogMode } = useStoreContext();
  const router = useRouter();

  const redirectToProductDetail = (slug, broken = false, brokenVariantId = "") => {
    setSearchValue("");
    router.push(
      getProductRoute({
        productSlug: slug,
        storeBasePath,
        broken,
        brokenVariantId,
      }),
    );
  };

  const renderContent = () => (
    <>
      <div className={main.imgBox}>
        <Multimedia
          type="image"
          src={baseImage || NoImage}
          height={40}
          width={40}
          isNextImage={false}
        />
      </div>
      <div className={main.itemDetail}>
        {brandName && <p className="">{brandName}</p>}
        <div className={main.name}>{name}</div>
      </div>
    </>
  );

  return !isPreviewCatalogMode ? (
    <Button
      key={id}
      onClick={() => redirectToProductDetail(slug, broken, brokenVariantId)}
      onKeyDown={() => redirectToProductDetail(slug, broken, brokenVariantId)}
      customClass={main.searchedItem}
    >
      {renderContent()}
    </Button>
  ) : (
    <>
      <Button
        key={id}
        onClick={(e) => {
          e.preventDefault();
          openProductDetailsModalCatalog(id);
        }}
        onKeyDown={openProductDetailsModalCatalog}
        customClass={main.searchedItem}
      >
        {renderContent()}
      </Button>
      {renderProductDetailsModalCatalog({
        classes: {
          rootClass: main.productDetailsCatalogPrimaryModal,
          dialogClass: `${main.modalDialogCatalogProductDetails} ${main.revampDesign}`,
        },
        data: {
          ...getPreviewCatalogModalDetail(data),
          classes: {
            productImgClass: main.catalogModeImgSection,
            productContentClass: main.catalogModeContentClass,
          },
        },
      })}
    </>
  );
};

export default SearchedProducts;
